<template>
  <v-dialog v-model="isRoomOpen" scrollable persistent max-width="600">
    <v-card>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-wechat</v-icon>
          {{
            $vuetify.lang.t(
              "$vuetify.courseManagement.liveStep.addLiveDialog.addRoom"
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="clearData">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-row>
            <v-col cols="12">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    "$vuetify.courseManagement.liveStep.addLiveDialog.title"
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                v-model="title"
                :rules="nameRules"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.room'
                  )
                "
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="clearData"
          >{{
            $vuetify.lang.t(
              "$vuetify.courseManagement.liveStep.addLiveDialog.cancel"
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          :disabled="!valid"
          :loading="loading"
          @click="validate"
          >{{
            $vuetify.lang.t(
              "$vuetify.courseManagement.liveStep.addLiveDialog.save"
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { insertChatRoom, updateChatRoom } from "@/service/course/livev2";
export default {
  props: {
    isRoomOpen: {
      type: Boolean,
    },
    isRoomClose: {
      type: Function,
    },
    liveId: {
      type: String,
    },
    room: {
      type: Object,
    },
  },
  watch: {
    isRoomOpen: async function (newValue) {
      if (newValue) {
        if (this.room) {
          this.title = this.room.title;
        }
      }
    },
  },
  data: () => ({
    valid: true,
    title: "",
    loading:false,
  }),

  computed: {
    nameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.courseManagement.liveStep.addLiveDialog.titleRules"
          ),
      ];
    },
  },

  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        if (this.room == null) {
          this.loading = true
          let result = await insertChatRoom({
            idlivestream: this.liveId,
            title: this.title,
            islive: true,
          });
          if (result.status !== false) {
            this.clearData();
            this.loading = false
          }
        } else {
          let result = await updateChatRoom({
            idlivestream: this.liveId,
            idchat: this.room._id,
            title: this.title,
            islive: true,
          });
          if (result.status !== false) {
            this.clearData();
            this.loading = false
          }
        }
      }
    },
    clearData() {
      this.title = "";
      this.$refs.form.resetValidation();
      this.isRoomClose();
    },
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
</style>